var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCanvas = function SvgCanvas(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 526.35 556.08",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#38509E",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.85 401.42h-520V117.04a8.12 8.12 0 0 1 8.12-8.12h503.75a8.12 8.12 0 0 1 8.12 8.12v284.38zM3.85 401.42h520v57.19c0 4.31-3.49 7.81-7.81 7.81H11.66c-4.31 0-7.81-3.49-7.81-7.81z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#38509E",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.97 552.67h-92.92c-3.42 0-6.19-2.77-6.19-6.19V371.64c0-3.42 2.77-6.19 6.19-6.19h92.92c3.42 0 6.19 2.77 6.19 6.19v174.83c0 3.42-2.77 6.2-6.19 6.2zM333.85 523.41h105.31M333.85 385.19h105.31"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M373.34 375.32h26.33"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.51,
    cy: 538.22,
    r: 8.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#38509E",
    strokeMiterlimit: 10,
    strokeWidth: 0.838
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.85 202.33V17.04c0-6.82 5.53-12.35 12.35-12.35h271.76c6.82 0 12.35 5.53 12.35 12.35v185.29c0 6.82-5.53 12.35-12.35 12.35H86.2c-6.82.01-12.35-5.53-12.35-12.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62 17.04v185.29H102.68V17.04z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.32,
    cy: 109.69,
    r: 8.24
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCanvas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas.b914e10c11f7f4b3299ab68574c54e66.svg";